import React from "react";
import Homebanner from "../assets/images/Homebanner.png";
import { Navigate, useNavigate } from "react-router-dom";

function Banner() {
  const Navigate = useNavigate();
  const navigateToPage = (pages) => {
    Navigate(pages);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };
  return (
    <div className="banner d-flex justify-content-center align-items-center">
      <img src={Homebanner} />
      <div className="banner-text d-flex flex-column gap-3 gap-md-4 text-white justify-content-center">
        <div>
          <h4 className="font-face-PlusJakartaSans-Regular">0% Commission</h4>
          <h1 className="font-face-PlusJakartaSans-Bold">
            Sell Your Home <span className="d-block"> with Ease!</span>
          </h1>
        </div>
        <p className="font-face-PlusJakartaSans-Regular">
          Manage all your real estate transactions in one platform that{" "}
          <span className="d-lg-block">
            connects buyers and sellers, guiding them through the process!
          </span>
        </p>
        <div className="d-flex  gap-2">
          <a
            href="https://apps.apple.com/us/app/realtybase/id1581598890"
            target="_blank"
          >
            <button className="btnone font-face-PlusJakartaSans-Bold">
              Download Now
            </button>
          </a>
          <button
            className="btnTwo font-face-PlusJakartaSans-Bold"
            onClick={() => {
              navigateToPage("/how-it-works");
            }}
          >
            How it Works
          </button>
        </div>
      </div>
    </div>
  );
}

export default Banner;
